module.exports = __webpack_public_path__ + "img/team-4.66618a41.jpg";